import { Injectable } from '@angular/core';


import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment as config } from 'src/environments/environment';
import { QdReturnType } from '../infrastructure/qd-return-type';


// declare var CryptoJS: any;
var CryptoJS = require("crypto-js");
@Injectable()
export class ApiService {
  private QDVideoChatAppUrl :string ; 
  constructor(public http: HttpClient) {
   }
  public CreateQDVideoChatUser(UID: string, User_Name: string, Avatar: string = ""): Observable<any> {

    
    if (Avatar == '') Avatar = `${location.origin}/assets/img/d-image.png`;
    var headers = new HttpHeaders((
      {
        'apikey': config.apiKey,
        'appid': config.appId
      }
    ));
    var Payload = {
      "uid": UID,
      "name": User_Name,
      "status": "offline",
      "avatar": Avatar
    }
    return this.http.post(config.QdVChatBaseUrl + 'users', Payload, { 'headers': headers})
  }
  public AddToPatientsFriendList(UID: string, Cons_UserId : string): Observable<any> {
    
    var Url = config.QdVChatBaseUrl + UID + '/friends' 
    var headers = new HttpHeaders((
      {
        'apikey': config.apiKey,
        'appid': config.appId
      }
    ));
    var Payload = { "accepted": [Cons_UserId] }
    return this.http.post(Url, Payload, { 'headers': headers })
  }
  public AddToConsultantFriendList(Cons_UserId: string,UID: string): Observable<any> {
    var Url = config.QdVChatBaseUrl + 'users/' + Cons_UserId + '/friends'
    var headers = new HttpHeaders((
      {
        'apikey': config.apiKey,
        'appid': config.appId
      }
    ));
    var Payload = { "accepted": [UID] }
    return this.http.post(Url, Payload, { 'headers': headers })
  }
  

  private handleError(error: any) {
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  public CommonService(url, param) : Observable<QdReturnType> {
    debugger;
    return this.http.post<QdReturnType>(config.apiBaseUrl + url, this.createPayload(param))
  }
  public CommonAdminService(url, param): Observable<QdReturnType> {
    debugger;
    return this.http.post<QdReturnType>(config.apiBaseUrl + url, this.createAdminPayload(param))
  }
  
  public CommonServiceWithoutToken(url, param) {
    debugger;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    };
    return this.http.post(config.apiBaseUrl + url, param, httpOptions).pipe(
      map(res => <any>res)
    )
  }
  createPayload(payload) {
    var _loggedInInfo = localStorage.getItem('LoggedInInfo')
    let LoggedInInfo = JSON.parse(_loggedInInfo);
    //LoggedInInfo.Loc_Id = 10
    return { LoggedInInfo: LoggedInInfo, Payload: payload };
  }
  Encrypt(param) : any {
    var key = CryptoJS.enc.Utf8.parse('kdyCRlcDOSuul4mE');
    var iv = CryptoJS.enc.Utf8.parse('kdyCRlcDOSuul4mE');
    var encryptedValue = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(param), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encryptedValue;
  }
  Decrypt(param) : any {
    var key = CryptoJS.enc.Utf8.parse('kdyCRlcDOSuul4mE');
    var iv = CryptoJS.enc.Utf8.parse('kdyCRlcDOSuul4mE');
    var decrypted = CryptoJS.AES.decrypt(param, key, { iv: iv });
   // return decrypted.toString(CryptoJS.enc.Utf8);
    let decryptedValue: any = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    return decryptedValue;
  }

  createAdminPayload(payload) {
    let Admininfo = JSON.parse(localStorage.getItem("Admininfo") || '{}');
    let GetClietID = localStorage.getItem("ClientID");

    return {
      LoggedInInfo: {
        Faci_Id: Admininfo.Faci_Id, 
        blIsFacilityID: true, 
        loc_id: Admininfo.Loc_ID,
        Usr_id: Admininfo.Usr_Id, 
        facId: Admininfo.Faci_Id,
        clientID: GetClietID // Now it won't be undefined
      }, 
      Payload: payload
    };
}

  public postAdminApiwithToken(url, param=undefined) {
    const token: string = localStorage.getItem("AdminTocken");
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    };
    debugger
    return this.http.post(config.apiBaseUrl + url, this.createAdminPayload(param), httpOptions).pipe(
      map(res => <any>res)
    )
  }
}
